export const Info_TAG_ICONS = {
  hintReservation:
    'https://cdn.naviparking.com/digital_parking/info_tags/hint_reservation.svg',
  hintSubscription:
    'https://cdn.naviparking.com/digital_parking/info_tags/hint_subscription.svg',
  dateIcon: 'https://cdn.naviparking.com/digital_parking/assets/date_icon.svg',
  timeIcon: 'https://cdn.naviparking.com/digital_parking/assets/time_icon.svg',
  autopay: 'https://cdn.naviparking.com/digital_parking/info_tags/autopay.svg',
  charging:
    'https://cdn.naviparking.com/digital_parking/info_tags/charging.svg',
  navipayMini:
    'https://cdn.naviparking.com/digital_parking/info_tags/navipay-mini.svg',
  planeIcon:
    'https://cdn.naviparking.com/digital_parking/info_tags/plane-icon.svg',
  scooterIcon:
    'https://cdn.naviparking.com/digital_parking/info_tags/scooter-icon.svg',
  valetIcon:
    'https://cdn.naviparking.com/digital_parking/info_tags/valet-icon.svg',
  carWashIcon:
    'https://cdn.naviparking.com/digital_parking/info_tags/wash-icon.svg'
} as const

export type InfoTagIconKey = keyof typeof Info_TAG_ICONS

export const getParkingTagIcon = (iconType: InfoTagIconKey): string => {
  return Info_TAG_ICONS[iconType]
}

export enum InfoTagType {
  HINT_RESERVATION = 'hintReservation',
  HINT_SUBSCRIPTION = 'hintSubscription',
  DATE_ICON = 'dateIcon',
  TIME_ICON = 'timeIcon',
  AUTOPAY = 'autopay',
  CHARGING = 'charging',
  NAVIPAY_MINI = 'navipayMini',
  PLANE_ICON = 'planeIcon',
  SCOOTER_ICON = 'scooterIcon',
  VALET_ICON = 'valetIcon',
  CAR_WASH_ICON = 'carWashIcon'
}
